export const removeAccents = (str) => {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D');
};

export const removeSpecialCharaters = (str) => {
  return str.replace(/[^a-zA-Z0-9]/g, '');
};
